import { useQuery } from '@tanstack/react-query';
import type { Contact } from '@kontor/shared';
import { api } from '../../api';
import { useSession } from '../../session';

/**
 * Volle Anschrift des gewählten Empfängers im Angebotseditor (KON-114), damit man vor dem Abschließen sieht, wohin das Angebot geht. Fehlt etwas, steht ein
 * Hinweis da. Ohne Recht auf Kontakte bleibt es beim Namen.
 */
export function RecipientCard({ contactId }: { contactId: string }) {
  const { can } = useSession();
  const contact = useQuery({
    queryKey: ['contact', contactId],
    queryFn: async () => (await api<{ data: Contact }>('GET', `/contacts/${contactId}`)).data,
    enabled: can('contacts.read'),
  });
  const company = useQuery({
    queryKey: ['contact', contact.data?.companyId],
    queryFn: async () => (await api<{ data: Contact }>('GET', `/contacts/${contact.data!.companyId}`)).data,
    enabled: !!contact.data?.companyId,
    retry: false,
  });
  if (!contact.data) return null;
  const c = contact.data;
  const missing = !c.street || !c.postalCode || !c.city;
  return (
    <address className="recipient-card">
      {company.data && <div>{company.data.name}</div>}
      <strong>{c.name}</strong>
      {c.street && <div>{c.street}</div>}
      {(c.postalCode || c.city) && <div>{[c.postalCode, c.city].filter(Boolean).join(' ')}</div>}
      {(c.email || c.phone) && <div className="muted small">{[c.email, c.phone].filter(Boolean).join(' · ')}</div>}
      {missing && <div className="recipient-card__warn small">Die Anschrift ist unvollständig. <a href={`/kontakte/${c.id}/bearbeiten`} target="_blank" rel="noreferrer">Im Kontakt ergänzen</a></div>}
    </address>
  );
}
